import React from "react";
function Home() {
    return (
        <div className="Home">
            <p class="h1 JJ-font">Welcome to Sakthi and Sandhya's Arangetram</p>
            <img src="Sakthi_Sandhya_Arangetram.png" class="Img-sizer border border-dark rounded" alt="Sakthi Sandhya Arangetram invitation"></img>
        </div>
    );
}
export default Home;